module.exports = __webpack_public_path__ + "img/21_60.3159c149.png";